import { useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import Breadcrumb from "@/components/base/Breadcrumb";
import VideoBrowser from "@/components/feature/VideoBrowser";
import CategorySidebar from "./components/CategorySidebar";
import { getCategoryById, getVideoTypes, getVideosByCategory } from "@/data/videos";
import usePageMeta from "@/hooks/usePageMeta";

export default function CategoryPage() {
  const { categoryId = "" } = useParams();
  const category = getCategoryById(categoryId);

  const videos = useMemo(() => getVideosByCategory(categoryId), [categoryId]);
  const typeOptions = useMemo(() => getVideoTypes(categoryId), [categoryId]);

  usePageMeta(
    category
      ? `${category.name} - 高清在线视频观看 - 视频分类 - 免费视频网站91`
      : "视频分类 - 免费视频网站91",
    category
      ? `免费视频网站91 ${category.name}分类，${category.description}畅享高清流畅的免费在线观看体验。`
      : "免费视频网站91 视频分类页面，汇集电影、电视剧、综艺、动画、纪录片等免费高清视频。",
    `免费视频网站91,${category ? category.name : "视频分类"},免费视频,在线视频观看,免费高清视频`,
  );

  if (!category) {
    return (
      <div className="container-page flex min-h-[60vh] flex-col items-center justify-center py-20 text-center">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-200 text-foreground-400">
          <i className="ri-error-warning-line text-3xl"></i>
        </span>
        <h1 className="mt-4 font-heading text-xl font-bold text-foreground-950">
          分类不存在或已下架
        </h1>
        <p className="mt-2 text-sm text-foreground-500">
          你访问的分类可能已被移除，返回首页继续浏览其他内容吧。
        </p>
        <Link
          to="/"
          className="mt-6 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
      </div>
    );
  }

  return (
    <>
      <div className="border-b border-background-200/70 bg-background-100">
        <div className="container-page py-4">
          <Breadcrumb
            items={[
              { label: "首页", to: "/" },
              { label: "视频分类", to: "/search" },
              { label: category.name },
            ]}
          />
        </div>
      </div>

      <div className="container-page py-8 md:py-10">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-[220px_1fr] lg:gap-8">
          <CategorySidebar activeId={categoryId} />

          <div>
            <div className="mb-6">
              <h1 className="flex items-center gap-2 font-heading text-2xl font-extrabold text-foreground-950 md:text-3xl">
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className={`${category.icon} text-xl`}></i>
                </span>
                {category.name}
              </h1>
              <p className="mt-2 max-w-3xl text-sm leading-relaxed text-foreground-500">
                {category.description}
              </p>
            </div>

            <VideoBrowser videos={videos} typeOptions={typeOptions} pageSize={6} />
          </div>
        </div>
      </div>
    </>
  );
}